import { Alert, Box, Button } from "@mui/material";
import { AccessSharepointListItem } from '../../models/SharePointTypes';
import { StoreRequestProjectAccess } from "../../hooks/SharePointStore";
import { useEffect, useState } from "react";
import * as React from "react";



export default function RequestAccess({ users, currentProjectId, currentServiceId, isButtonDisable }: any) {

    const { isLoading,isFinished,requestProjectAccess } = StoreRequestProjectAccess();
    const [isRequestClicked, setIsRequestClicked] = useState(false);


    useEffect(() => {
        if (isRequestClicked && users.length != 0) {
            sendRequest();
        }
    }, [isRequestClicked]);

    
    function sendRequest () {
        var requestAccessToSend: AccessSharepointListItem = { requestStatus: "en cours", serviceId: Number(currentServiceId), userList: users , idIovision: currentProjectId};
        console.log("sending access request");
        requestProjectAccess(Number(currentProjectId),requestAccessToSend);
    }



    return (
        <Box>
            {(isRequestClicked && !isLoading && isFinished) && (
                <React.Fragment><Alert severity="success">La demande d'ajout a bien été envoyée.</Alert></React.Fragment>
            )}
            {(isRequestClicked && !isLoading && !isFinished) && (
                <React.Fragment><Alert severity="error">Une erreur est survenue. Contactez un administrateur</Alert></React.Fragment>
            )}
            <Button
                variant="contained"
                size="small"
                disabled={isButtonDisable}
                onClick={() => setIsRequestClicked(true)}
                sx={{
                    color: "background.paper",
                    borderColor: "background.paper",
                    marginRight: 5,
                }}
            > Valider
            </Button>
        </Box>
    );
}